import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

/**
 * Concesionarias del grupo con sus sucursales (para filtros del reporte
 * grupal de subastas finalizadas).
 */
export const getDealershipsByGroupV2 = async (groupId) => {
  if (!groupId) {
    console.error("ID de grupo no proporcionado");
    throw new Error("ID de grupo no proporcionado");
  }

  try {
    const getDealershipsFn = httpsCallable(
      functions,
      "getDealershipsByGroupV2",
    );
    const result = await getDealershipsFn({
      groupId,
      requestedApp: "group_web",
    });

    if (result.data && result.data.success === "yes") {
      return result.data.data || [];
    }
    throw new Error(
      result.data?.message || "Error al obtener concesionarias del grupo",
    );
  } catch (error) {
    console.error("Error obteniendo concesionarias del grupo:", error);
    notifyPermissionDenied(error);
    throw error;
  }
};
